import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCoins } from '@/shared/api/shop/coins';
import { getCartItems } from '@/shared/api/shop/orders';
import { getSeenNews } from '@/shared/api/user';
import type { CartItem, EntityId, UserSeenNews } from './types';

export const fetchSeenNews = createAsyncThunk<
  UserSeenNews,
  EntityId | undefined
>('user/fetchSeenNews', (userID) => getSeenNews(userID));

export const fetchCartItems = createAsyncThunk<
  CartItem[],
  EntityId | undefined
>('cart/fetchCartItems', (userID) => getCartItems(userID));

export const fetchCoins = createAsyncThunk<number, EntityId | undefined>(
  'cart/fetchCoins',
  (userID) => getCoins(userID)
);
